import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ModalController, ViewWillEnter } from '@ionic/angular';
import { AccommodationService } from 'src/app/services/accommodation.service';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { ModalMakerService } from 'src/app/services/modal-maker.service';

@Component({
  selector: 'app-my-accommodations',
  templateUrl: './my-accommodations.component.html',
  styleUrls: ['./my-accommodations.component.scss'],
})
export class MyAccommodationsComponent implements OnInit, ViewWillEnter, OnDestroy {

  constructor(
    private mdlctrl: ModalController,
    public dataServ: DataService,
    public authServ: AuthService,
    public accomServ: AccommodationService,
    public modalServ: ModalMakerService,
    private titleService: Title
  ) { }

  async ngOnInit() {
    if (!this.authServ.profile) {
      await this.authServ.getMe();
    }

    await this.accomServ.getVisits(this.authServ.profile.id);
  }

  ionViewWillEnter(): void {
    this.titleService.setTitle('My Accommodations');
  }

  ngOnDestroy(): void {
    this.titleService.setTitle('My Profile');
  }

  async close() {
    await this.mdlctrl.dismiss();
  }
}
